import asyncActionTypes from '../actions/types';

const initialState = {
  isCartSessionModalOpen: false,
  sessionData: { cartId: null },
  error: {},
};

const sessionValidation = (state = initialState, action) => {
  switch (action.type) {
    case asyncActionTypes.UPDATE_CART_SESSION_DATA.START:
      return {
        ...state,
      };
    case asyncActionTypes.UPDATE_CART_SESSION_DATA.SUCCESS:
      return {
        ...state,
        sessionData: action.payload,
      };
    case asyncActionTypes.UPDATE_CART_SESSION_DATA.FAIL:
      return {
        ...state,
        error: action.payload,
      };
    case asyncActionTypes.SET_IS_CART_SESSION_MODAL_OPEN.SUCCESS:
      return {
        ...state,
        isCartSessionModalOpen: true,
      };
    case asyncActionTypes.SET_IS_CART_SESSION_MODAL_CLOSED.SUCCESS:
      return {
        ...state,
        isCartSessionModalOpen: false,
      };
    default:
      return state;
  }
};

export default sessionValidation;
